import { useEffect, useState } from "react";
import Loader from "../../components/Common/Loader";
import ReplaceRecipeModal from "./ReplaceRecipeModal";
import RecipeDrawer from "./RecipeDetailsDrawer";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchFavoriteRecipesThunk,
  fetchRecipesByNameThunk,
  postFavoriteRecipeThunk,
} from "../../redux/Slices/recipesListSlice";
import { CONSTANTS } from "../../utils/Constant/Constant";
import useCustomTranslation from "../../hooks/useCustomTranslation";
import ToastNotification from "../../components/Common/ToastNotification";
import {
  deleteRecipeThunk,
  resetRecipeState,
} from "../../redux/Slices/updateStandardRecipeSlice";
import { Modal, Button } from "react-bootstrap";

const RecipesCard = ({
  isToolbox,
  recipe,
  filteredRecipes,
  recipesList,
  isClickedFromSwapRecipe = false,
  onClick,
  handleRecipeUpdate,
  mealType,
  selectedMeals,
  formData,
  exclude,
  mealPercentages,
  isToggled,
  setMakeFavoriteMessage,
  dietaryPreferences,
  allergies,
  numberOfRecipesPerMeal,
  recipeId,
  fetchData,
}) => {
  const dispatch = useDispatch();
  const { trans } = useCustomTranslation();
  const { profileData } = useSelector((state) => state.profile);
  const { loading, deleteSuccess, error } = useSelector(
    (state) =>
      state.recipe || { loading: false, deleteSuccess: false, error: null }
  );

  const [imageLoaded, setImageLoaded] = useState(false);
  const [showReplaceModal, setShowReplaceModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [selectedRecipe, setSelectedRecipe] = useState({});
  const [toastConfig, setToastConfig] = useState(null);
  const [toastMessage, setToastMessage] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRecipeId, setSelectedRecipeId] = useState(null);

  const handleCardClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isClickedFromSwapRecipe) {
      onClick();
    } else {
      setShowReplaceModal(true);
    }
  };

  const handleInfoClick = (e) => {
    e.stopPropagation();
    let recipesId = recipe?.recipeId ? recipe?.recipeId : recipe?.id;
    setSelectedRecipeId(recipesId);
    setSelectedRecipe(recipe);
    setShowInfoModal(true);
  };
  // eslint-disable-next-line no-unused-vars
  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    const recipeId = recipe?.databaseId
      ? recipe?.databaseId
      : recipe.databaseId;
    const coachId = profileData?.coachId;

    dispatch(postFavoriteRecipeThunk({ coachId, recipeId })).then((result) => {
      if (result?.payload?.data?.userFavoriteRecipe) {
        const isFavorite =
          result.payload.data.userFavoriteRecipe.isUserFavorite;

        setMakeFavoriteMessage(
          isFavorite
            ? trans("ClientMealPlan.recipeFavoriteAdded")
            : trans("ClientMealPlan.recipeFavoriteRemoved")
        );

        isToolbox &&
          setMakeFavoriteMessage(
            isFavorite
              ? trans("ClientMealPlan.recipeFavoriteAdded")
              : trans("ClientMealPlan.recipeFavoriteRemoved")
          );
        const FilterData = {
          recipeName: "",
          mealTime: "",
          cuisines: [],
          tags: [],
          macroNutrientsRange: {},
          mealRestrictions: "",
        };

        // Make favorite and un-favorite api calls
        isToggled
          ? dispatch(fetchFavoriteRecipesThunk({ coachId }))
          : dispatch(fetchRecipesByNameThunk({ FilterData, coachId }));
      }
    });
  };

  const handleModalClose = () => {
    setShowReplaceModal(false);
  };

  useEffect(() => {
    if (deleteSuccess) {
      setToastConfig({
        type: CONSTANTS.TOAST_SUCCESS,
        message:
          trans("Common.recipeDeletedSuccessfully") ||
          "Recipe deleted successfully!",
        heading: trans("Common.success"),
      });
      setTimeout(() => {
        setToastConfig(null);
        dispatch(resetRecipeState());
      }, 3000);
    }

    if (error) {
      setToastConfig({
        type: CONSTANTS.TOAST_ERROR,
        message:
          trans("Common.recipeDeletedFailed") || "Failed to delete recipe!",
        heading: trans("Common.error"),
      });
      setTimeout(() => {
        setToastConfig(null);
        dispatch(resetRecipeState());
      }, 3000);
    }
  }, [deleteSuccess, error, dispatch, trans]);

  useEffect(() => {
    if (!toastConfig && toastMessage !== "") {
      setToastConfig({
        type: CONSTANTS.TOAST_SUCCESS,
        message: toastMessage,
        heading: trans("Common.success"),
      });
      setTimeout(() => {
        setToastConfig(null);
        setToastMessage("");
      }, 3000);
    }
  }, [toastMessage, trans, toastConfig]);

  const handleDeleteRecipe = () => {
    setShowDeleteModal(true);
  };

  const confirmDeleteRecipe = async () => {
    try {
      await dispatch(deleteRecipeThunk(recipe?.recipeId)).unwrap();

      setToastConfig({
        type: CONSTANTS.TOAST_SUCCESS,
        message:
          trans("Common.recipeDeletedSuccessfully") ||
          "Recipe deleted successfully!",
        heading: trans("Common.success"),
      });
    } catch (err) {
      setToastConfig({
        type: CONSTANTS.TOAST_ERROR,
        message:
          trans("Common.recipeDeletedFailed") || "Failed to delete recipe!",
        heading: trans("Common.error"),
      });
    } finally {
      // Always close modal and reset Redux state
      setShowDeleteModal(false);
      setTimeout(() => {
        dispatch(resetRecipeState());
        setToastConfig(null);
        fetchData();
      }, 3000);
    }
  };

  return (
    <>
      <div
        className="card recipe-card position-relative p-0 w-200 cursor-pointer"
        onClick={(e) => {
          if (e.target.closest(".delete-circle")) return;
          if (isToolbox) handleInfoClick(e);
          else handleCardClick(e);
        }}
        key={recipe?.id}
      >
        <div className="info-icon position-absolute top-0 end-0 p-2">
          <div
            className="d-flex justify-content-end position-absolute top-0 end-5 p-2 gap-2"
            style={{ right: "-5px" }}
          >
            {/* <div onClick={handleFavoriteClick}>
                {recipe?.isUserFavorite === true ||
                recipe?.isUserFavorite === "true" ? (
                  <i className="bi bi-heart-fill text-danger"></i>
                ) : (
                  <i className="bi-heart text-white"></i>
                )}
              </div> */}
            {!isToolbox ? (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  handleInfoClick(e);
                }}
                className="icon-circle"
              >
                <i className="bi bi-info-circle-fill text-white fs-7"></i>
              </div>
            ) : (
              profileData?.isAdmin && (
                <div
                  className="delete-circle d-flex justify-content-center align-items-center"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteRecipe();
                  }}
                >
                  <i className="bi bi-trash3-fill text-white fs-5"></i>
                </div>
              )
            )}
          </div>
        </div>

        <div className="recipe-overlay">
          <h6 className="card-title">{recipe?.title || recipe?.name}</h6>
          <div className="full-title">{recipe?.title || recipe?.name}</div>
        </div>

        {!imageLoaded && <Loader message="" />}

        <img
          src={recipe?.mainImage || "/placeholder-image.jpg"}
          alt={recipe?.title || recipe?.name}
          className={`card-img-top recipe-image ${
            imageLoaded ? "visible" : "hidden"
          }`}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageLoaded(true)}
        />
      </div>

      {showReplaceModal && (
        <ReplaceRecipeModal
          show={showReplaceModal}
          onHide={handleModalClose}
          selectedRecipes={filteredRecipes}
          recipesList={recipesList}
          handleRecipeUpdate={handleRecipeUpdate}
          mealType={mealType}
          selectedMeals={selectedMeals}
          formData={formData}
          exclude={exclude}
          mealPercentages={mealPercentages}
          allergies={allergies}
          dietaryPreferences={dietaryPreferences}
          numberOfRecipesPerMeal={numberOfRecipesPerMeal}
        />
      )}

      <RecipeDrawer
        recipeDetails={selectedRecipe}
        visible={showInfoModal}
        onClose={() => setShowInfoModal(false)}
        fetchData={fetchData}
        isToolbox={isToolbox}
        isAdmin={profileData?.isAdmin}
      />

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {trans("Common.confirmation")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{trans("Common.areYouSureDeleteRecipe")}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-primary"
            onClick={() => setShowDeleteModal(false)}
            className="back_button w-25 p-1"
          >
            {trans("Common.cancel")}
          </Button>
          <Button
            className="saveButton w-25 ml-2"
            onClick={confirmDeleteRecipe}
          >
            {trans("Common.delete")}
          </Button>
        </Modal.Footer>
      </Modal>

      {toastConfig && (
        <ToastNotification
          type={toastConfig.type}
          message={toastConfig.message}
          heading={toastConfig.heading}
        />
      )}
    </>
  );
};

export default RecipesCard;
